import { addCache } from 'api/caching'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'

import { BannerRequestBody } from './types'

export const getChangelogSummary = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<any>> =>
    orgScopedApiClient.post('/api/changelog/summary/banner/', params, {
        headers: getCerebroHeaders(options.headers),
    })
addCache(getChangelogSummary)

export const getChangelogSummaryExport = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post('/api/changelog/summary/banner/export/', params, {
        headers: getCerebroHeaders(options.headers),
    })
